import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { ContentArchive } from "./useContentArchive";

const useStyles = makeStyles((theme: any) => ({
  button: {
    textTransform: "none",
    borderColor: theme.palette.secondary.main,
    color: theme.palette.secondary.main,
    whiteSpace: "nowrap",
    [theme.breakpoints.down("sm")]: { fontSize: 12, height: 39 },
  },
}));

/**
 * Header control that moves between the live list and its archive. In the archive it becomes a
 * "Back to <plural>" button, which is what gives the archived view the back route the story asks for.
 */
const ArchiveViewButton = ({ archive }: { archive: ContentArchive }) => {
  const styles = useStyles();

  return archive.archived ? (
    <Button
      variant="outlined"
      className={styles.button}
      startIcon={<ArrowBackIcon />}
      onClick={archive.showLive}
    >
      Back to {archive.label.plural}
    </Button>
  ) : (
    <Button
      variant="outlined"
      className={styles.button}
      startIcon={<ArchiveOutlinedIcon />}
      onClick={archive.showArchived}
    >
      Archived
    </Button>
  );
};

export default ArchiveViewButton;
